import { Action, Reducer } from 'redux'
import { SHIPPER_RATE_STATUS } from 'apps/rms/constants/shipperRates'
import {
  IShipperRatesState,
  IShipperRate,
  IShipperRatesParams,
  SORT_FIELD,
  SORT_ORDER,
  IActiveStatusCounts,
} from 'apps/rms/types/shipperRates'
import {
  SHIPPER_RATES_ACTIONS,
  CREATE_SHIPPER_RATES_ACTIONS,
  UPDATE_SHIPPER_RATES_ACTIONS,
  SET_ACTIVE_TAB,
  BULK_CREATE_SHIPPER_RATES_ACTIONS,
  BULK_UPDATE_SHIPPER_RATES_ACTIONS,
} from '../actions/shipperRates'

const {
  SHIPPER_RATES_FAILURE,
  SHIPPER_RATES_REQUEST,
  SHIPPER_RATES_SUCCESS,
} = SHIPPER_RATES_ACTIONS

const {
  CREATE_SHIPPER_RATES_FAILURE,
  CREATE_SHIPPER_RATES_REQUEST,
  CREATE_SHIPPER_RATES_SUCCESS,
} = CREATE_SHIPPER_RATES_ACTIONS

const {
  BULK_CREATE_SHIPPER_RATES_FAILURE,
  BULK_CREATE_SHIPPER_RATES_REQUEST,
  BULK_CREATE_SHIPPER_RATES_SUCCESS,
} = BULK_CREATE_SHIPPER_RATES_ACTIONS

const {
  UPDATE_SHIPPER_RATES_FAILURE,
  UPDATE_SHIPPER_RATES_REQUEST,
  UPDATE_SHIPPER_RATES_SUCCESS,
} = UPDATE_SHIPPER_RATES_ACTIONS

const {
  BULK_UPDATE_SHIPPER_RATES_FAILURE,
  BULK_UPDATE_SHIPPER_RATES_REQUEST,
  BULK_UPDATE_SHIPPER_RATES_SUCCESS,
} = BULK_UPDATE_SHIPPER_RATES_ACTIONS

interface IRequestAction extends Action<string> {
  payload: {
    requestData: {
      params: IShipperRatesParams
    }
  }
}

interface ISuccessAction extends Action<string> {
  payload: {
    shipperRates: IShipperRate[]
    totalCount: number
    activeStatusCounts: IActiveStatusCounts
  }
}

interface IErrorAction extends Action<string> {
  error: string
}

interface ITabAction extends Action<string> {
  payload: {
    tab: SHIPPER_RATE_STATUS
  }
}

type ShipperRatesAction = IRequestAction | ISuccessAction | IErrorAction | ITabAction

const defaultState: IShipperRatesState = {
  fetching: false,
  shipperRates: [],
  totalCount: 0,
  activeTab: SHIPPER_RATE_STATUS.ACTIVE,
  activeStatusCounts: {
    all: 0,
    active: 0,
    upcoming: 0,
    inactive: 0,
  },
  params: {
    pageCount: 0,
    perPage: 15,
    sortField: SORT_FIELD.id,
    sortOrder: SORT_ORDER.ASC,
  },
}

const shipperRatesReducer: Reducer<IShipperRatesState, ShipperRatesAction> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SHIPPER_RATES_REQUEST: {
      const {
        payload: {
          requestData: { params },
        },
      } = action as IRequestAction
      return {
        ...state,
        fetching: true,
        error: undefined,
        params,
      }
    }
    case SHIPPER_RATES_SUCCESS: {
      const {
        payload: { activeStatusCounts, shipperRates, totalCount },
      } = action as ISuccessAction
      return {
        ...state,
        fetching: false,
        shipperRates,
        totalCount,
        activeStatusCounts,
      }
    }
    case SHIPPER_RATES_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: (action as IErrorAction).error,
      }
    }
    case CREATE_SHIPPER_RATES_REQUEST:
    case BULK_CREATE_SHIPPER_RATES_REQUEST: {
      return {
        ...state,
        fetching: true,
        error: undefined,
      }
    }
    case CREATE_SHIPPER_RATES_SUCCESS:
    case BULK_CREATE_SHIPPER_RATES_SUCCESS: {
      return {
        ...state,
        fetching: false,
        error: undefined,
      }
    }
    case CREATE_SHIPPER_RATES_FAILURE:
    case BULK_CREATE_SHIPPER_RATES_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: (action as IErrorAction).error,
      }
    }
    case UPDATE_SHIPPER_RATES_REQUEST:
    case BULK_UPDATE_SHIPPER_RATES_REQUEST: {
      return {
        ...state,
        fetching: true,
        error: undefined,
      }
    }
    case UPDATE_SHIPPER_RATES_SUCCESS:
    case BULK_UPDATE_SHIPPER_RATES_SUCCESS: {
      return {
        ...state,
        fetching: false,
        error: undefined,
      }
    }
    case UPDATE_SHIPPER_RATES_FAILURE:
    case BULK_UPDATE_SHIPPER_RATES_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: (action as IErrorAction).error,
      }
    }
    case SET_ACTIVE_TAB: {
      return {
        ...state,
        activeTab: (action as ITabAction).payload.tab,
      }
    }
    default:
      return state
  }
}

export default shipperRatesReducer
